export default "__VITE_ASSET__ea8ca4f8__"